import GoBack from "./GoBack"

export default function Navbar({
  showSourceDoc,
  setShowSourceDoc,
  showTransDoc,
  setShowTransDoc,
  onSaveFile,
  srcLang,
  tgtLang,
  setShowFindReplace

}) {
  
  const openShabdakosh = () => {
    const word = window.getSelection().toString().trim();
   
    if (word) {
      const url = `https://www.shabdkosh.com/search-dictionary?lc=${tgtLang}&sl=${srcLang}&tl=${tgtLang}&e=${encodeURIComponent(word)}`;

      window.open(url, "_blank");
    } else {
      alert("Select a word first");
    }
  };

  return (
    <nav
      className={`flex items-center justify-between px-4 md:px-6 mx-2 border transition-colors duration-200 bg-slate-50 border-gray-300 text-gray-900`}
    >
      {/* LEFT SIDE */}
      <div className="flex items-center gap-4 md:gap-6">
        {/* Checkboxes */}
        <label className="flex items-center gap-1.5 text-sm cursor-pointer select-none">
          <input
            type="checkbox"
            className="w-4 h-4 accent-blue-600 dark:accent-blue-500"
            checked={showSourceDoc}
            onChange={(e) => setShowSourceDoc(e.target.checked)}
          />
          <span>Source Doc</span>
        </label>

        <label className="flex items-center gap-1.5 text-sm cursor-pointer select-none">
          <input
            type="checkbox"
            className="w-4 h-4 accent-blue-600 dark:accent-blue-500"
            checked={showTransDoc}
            onChange={(e) => setShowTransDoc(e.target.checked)}
          />
          <span>Target Doc</span>
        </label>

        <div>
          <button title="Shabdakosh dictionary" className="hover:text-blue-600 hover:underline" onClick={openShabdakosh}>
            shabdkosh
          </button>
        </div>
        <div>
          <button title="Find & Replace" className="hover:text-blue-600 hover:underline" onClick={() => setShowFindReplace(true)}>Find & Replace</button>
        </div>

        {/* <label className="flex items-center gap-1.5 text-sm cursor-pointer select-none">
          <input
            type="checkbox"
            className="w-4 h-4 accent-blue-600 dark:accent-blue-500"
            checked={mtEditedCompare}
            onChange={(e) => setMTEditedCompare(e.target.checked)}
          />
          <span>MT-edited compare</span>
        </label> */}
        <GoBack />
      </div>


      {/* RIGHT SIDE – Download + Profile */}
      <div className="flex items-center gap-1">
        {/* <button
          onClick={downloadTranslation}
          className={`
            text-xs px-4 py-2 transition-colors
            ${darkMode
              ? 'bg-emerald-700 hover:bg-emerald-600 text-white'
              : 'bg-emerald-600 hover:bg-emerald-700 text-white'}
          `}
        >
          Download
        </button> */}
        <button className="border border-gray-400 bg-gray-200 shadow-inherit px-2 py-1 hover:bg-gray-600 hover:text-gray-300 text-sm" onClick={onSaveFile}>Finish</button>
      </div>
    </nav>
  );
}